/*
 * @Author: lixin jiang
 * @Date: 2021-07-07 09:33:00
 * @LastEditTime: 2022-04-15 17:03:59
 * @LastEditors: Yehao Gao
 * @Description:
 * @FilePath: \kitchen-online-web\src\components\arcButton\ArcButton.jsx
 */
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ArcButtonGroupContext from './context';
import buttonStyle from './ArcButton.module.scss';

function ArcButton(props) {
  const {
    text,
    width,
    height,
    fontSize,
    checked,
    handleChecked,
    backgroundColor,
    position,
    top,
    unit,
    left,
    right,
    margin,
    border,
    // onCancel,
  } = props;

  const context = React.useContext(ArcButtonGroupContext);

  const [focus, setFocus] = useState(false);

  const iconSize = height / 1.71;

  const iconToTop = (height - iconSize) / 2;

  const handleClickButton = () => {
    // onCancel();
    if (!backgroundColor) {
      setFocus(true);
    }
    handleChecked(text);
    context?.onChange?.(text);
  };

  const handleBlurButton = () => {
    if (!backgroundColor) {
      setFocus(false);
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      className={
        `${buttonStyle['arc-button']}
        ${checked && focus && buttonStyle['arc-button-focus']}
        ${checked && !focus && buttonStyle['arc-button-active']}
        `
      }
      style={{
        width: `${width}rem`,
        height: `${height}rem`,
        borderRadius: `${height}rem`,
        backgroundColor: `${backgroundColor}`,
        position: `${position}`,
        top: `${top}${unit}`,
        left: `${left}${unit}`,
        right: `${right}${unit}`,
        margin: `${margin}`,
        border: `${border}`,
      }}
      onClick={() => handleClickButton()}
      onBlur={() => handleBlurButton()}
      aria-hidden
    >
      <span style={{
        color: `
        ${
          (backgroundColor === '#fff' || backgroundColor === '#ffffff') ? '#111111' : (backgroundColor && '#ffffff')
        }
        `,
        fontSize: `${fontSize}rem`,
      }}
      >
        {text}
      </span>
      {
        backgroundColor ? null : (
          <div
            className={
            `${buttonStyle['arc-checked-icon']}
            ${buttonStyle['arc-icon']} 
            ${focus ? buttonStyle['arc-focus-icon'] : buttonStyle['arc-checked-icon']} 
            ${checked && buttonStyle['show-checked-icon']}
            ${checked && !focus && buttonStyle['show-checked-icon']}
            `
          }
            style={{
              width: `${iconSize}px`,
              height: `${iconSize}px`,
              top: `${iconToTop}px`,
              right: `${iconToTop}px`,
            }}
          />
        )
      }
    </div>
  );
}

ArcButton.propTypes = {
  backgroundColor: PropTypes.string,
  text: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  checked: PropTypes.bool,
  handleChecked: PropTypes.func,
  position: PropTypes.string,
  top: PropTypes.number,
  left: PropTypes.number,
  right: PropTypes.number,
  margin: PropTypes.string,
  border: PropTypes.string,
  fontSize: PropTypes.number,
  unit: PropTypes.string,
  // onCancel: PropTypes.func,
};

ArcButton.defaultProps = {
  backgroundColor: '', // 按钮背景色
  text: '', // 按钮文案
  width: 20.875, // 按钮宽度
  height: 3.125, // 按钮高度
  checked: false, // 选中状态
  position: 'reactive',
  fontSize: 0.875,
  top: 0,
  left: 0,
  right: 0,
  margin: '',
  border: 'none',
  unit: 'px',
  handleChecked: () => {}, // 点击事件
  // onCancel: () => {},
};

export default ArcButton;
